import gsap from 'gsap'
import Component from '../classes/Component'

export default class extends Component {
  constructor () {
    super({
      classes: {},
      element: '.intro__slider__first',
      elements: {
        list: '.intro__slider__second__content ul',
        listItems: '.intro__slider__second__content ul li',
        // links: '.intro__slider__second__content ul li a',
        videos: '.intro__slider__first__content video'
      }
    })

    this.currentVideoIndex = 0

    this.TRANSITION_DURATION = 0.4

    this.create()
  }

  create () {
    this.elements.videos.forEach((video, index) => {
      if (index !== 0) {
        gsap.set(video, {
          opacity: 0
        })
      }
    })
  }

  addEventListeners () {
    // this.elements.links.addEventListener('click', e => {
    //   e.preventDefault()
    // })
    this.elements.list.addEventListener('mousemove', e => {
      const index = Number(e.target.dataset.index)
      if (this.currentVideoIndex === 0) {
        // if (this.elements.videos[index].querySelector('source').dataset.src) {
        //   this.elements.videos[index].querySelector('source').src = this.elements.videos[index].querySelector('source').dataset.src
        //   delete this.elements.videos[index].querySelector('source').dataset.src
        // }
        gsap.to(this.elements.videos[this.currentVideoIndex], {
          scale: 1.1,
          opacity: 0,
          duration: this.TRANSITION_DURATION,
          ease: 'power2.inOut'
        })
        gsap.to(this.elements.videos[index], {
          scale: 1,
          opacity: 1,
          duration: this.TRANSITION_DURATION,
          ease: 'power2.inOut'
        })
        this.currentVideoIndex = index
        this.elements.listItems.forEach((item, i) => {
          if (i !== index - 1) {
            gsap.to(item, {
              opacity: 0.3,
              duration: 0.2,
              ease: 'power2.inOut'
            })
          }
        })
      } else if (index !== this.currentVideoIndex) {
        gsap.to(this.elements.videos[this.currentVideoIndex], {
          scale: 1.1,
          opacity: 0,
          duration: this.TRANSITION_DURATION,
          ease: 'power2.inOut'
        })
        gsap.to(this.elements.videos[index], {
          scale: 1,
          opacity: 1,
          duration: this.TRANSITION_DURATION,
          ease: 'power2.inOut'
        })
        this.currentVideoIndex = index
        gsap.set(this.elements.listItems, {
          opacity: 0.3
        })
        gsap.set(this.elements.listItems[index - 1], {
          opacity: 1
        })
      }
    })
    this.elements.list.addEventListener('mouseleave', e => {
      gsap.to(this.elements.videos[this.currentVideoIndex], {
        scale: 1.1,
        opacity: 0,
        duration: this.TRANSITION_DURATION,
        ease: 'power2.inOut'
      })
      gsap.to(this.elements.videos[0], {
        scale: 1,
        opacity: 1,
        duration: this.TRANSITION_DURATION,
        ease: 'power2.inOut'
      })
      this.currentVideoIndex = 0
      gsap.to(this.elements.listItems, {
        opacity: 1,
        duration: 0.2,
        ease: 'power2.inOut'
      })
    })
  }
}
